module.exports = __webpack_public_path__ + "img/icon-statistic.6c2add5e.svg";